import { defineComponent as _defineComponent } from 'vue'
import { Course, Group, Project } from "ag-client-typescript";
import { reactive, watch, ref } from "vue";
import { use_datetime_model } from "@/composables/use_datetime_model";
import APIErrors from "@/components/api_errors.vue";
import { APIErrorsExposed } from "@/exposed_component_types/api_errors_exposed";
import GroupMembersForm from "@/components/group_members_form.vue";
import LastSaved from "@/components/last_saved.vue";
import Modal from "@/components/modal.vue";
import ValidatedIntInput from "@/components/validated_input/ValidatedIntInput.vue";
import { assert_not_null, deep_copy, format_datetime, toggle } from "@/utils";
import { make_min_validator } from "@/new_validators";

type PropTypes = {
  course: Course;
  group: Group;
  project: Project;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'edit_single_group',
  props: {
    course: null,
    group: null,
    project: null
  },
  setup(__props: any, { expose }) {

const props = __props as {
  course: Course;
  group: Group;
  project: Project;
};



const api_errors = ref<APIErrorsExposed>();
const delete_group_api_errors = ref<APIErrorsExposed>();

const state = reactive({
  group: null as Group | null,
  saving: false,
  edit_group_form_is_valid: true,
  show_delete_group_modal: false,
  deleting: false,
});

const extension_model = use_datetime_model({
  get_iso: () => state.group?.extended_due_date ?? null,
  set_iso: (v) => {
    if (state.group) state.group.extended_due_date = v;
  },
  get_timezone: () => props.project.timezone,
});

const update_group = () => {
  return toggle(state, "saving", async () => {
    assert_not_null(state.group);
    try {
      api_errors.value?.clear();
      await state.group.save();
    } catch (error: unknown) {
      api_errors.value?.show_errors_from_response(error);
    }
  });
};

const delete_group = () => {
  return toggle(state, "deleting", async () => {
    assert_not_null(state.group);
    try {
      await state.group.pseudo_delete();
      state.show_delete_group_modal = false;
    } catch (error: unknown) {
      delete_group_api_errors.value?.show_errors_from_response(error);
    }
  });
};

watch(
  () => props.group,
  (new_group: Group, old_group: Group) => {
    state.group = deep_copy(new_group, Group);
  },
);
state.group = deep_copy(props.group, Group);

expose({
  state,
});

return { __sfc: true,props, api_errors, delete_group_api_errors, state, extension_model, update_group, delete_group, APIErrors, GroupMembersForm, LastSaved, Modal, ValidatedIntInput, format_datetime, make_min_validator }
}

})